import { render, staticRenderFns } from "./ElStatusTag.vue?vue&type=template&id=ba2156b8"
import script from "./ElStatusTag.vue?vue&type=script&lang=js"
export * from "./ElStatusTag.vue?vue&type=script&lang=js"
import style0 from "./ElStatusTag.vue?vue&type=style&index=0&id=ba2156b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports